import React from "react";

export default function SignupFeedback({ status, message }) {
  if (!message) return null;
  return (
    <div
      className={
        "mt-2 border-2 px-4 py-3 font-display uppercase tracking-widest text-sm " +
        (status === "success"
          ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]"
          : "border-[hsl(var(--destructive))] text-[hsl(var(--destructive))]")
      }
      data-testid="signup-feedback"
      role="status"
    >
      {message}
    </div>
  );
}
